import { createBrowserRouter } from "react-router-dom";

import HomePage from "../pages/public/Home/HomePage";
import ServicesPage from "../pages/public/Services/ServicesPage";
import AdminLoginPage from "../pages/admin/Login/AdminLoginPage";
import ServicePage from "../pages/public/Services/ServicePage";
import PricePage from "../pages/Price/PricePage";
import AdminPanelPage from "../pages/admin/Panel/AdminPanel";
import BlogPage from "../pages/Blog/BlogPage";
import BlogPostPage from "../pages/Blog/BlogPostPage";
import { ProtectedRoute } from "./protectedRoute";
import ContactsPage from "../pages/Contacts/ContactsPage";
import TeamPage from "../pages/Team/TeamPage";
import TeamMemberPage from "../pages/TeamMember/TeamMemberPage";
import DocumentPage from "pages/Document/DocumentPage";
import PrivacyPolicyPage from "../pages/PrivacyPolicy/PrivacyPolicyPage";

export const router = createBrowserRouter([
  { path: "/", element: <HomePage /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/admin/login", element: <AdminLoginPage /> },
  { path: "/services/:id", element: <ServicePage /> },
  { path: "/price", element: <PricePage /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "/contacts", element: <ContactsPage /> },
  { path: "/blog/:id", element: <BlogPostPage /> },
  { path: "/team", element: <TeamPage /> },
  { path: "/team/:id", element: <TeamMemberPage /> },

  { path: "/document", element: <DocumentPage /> },
  { path: "/privacy-policy", element: <PrivacyPolicyPage /> },

  {
    path: "/admin/login/panel",
    element: (
      <ProtectedRoute>
        <AdminPanelPage />
      </ProtectedRoute>
    ),
  },
]);